<template>
  <div>
    <Detail
      :detailQuery="detailQuery"
      :title="title"
      :nodes="nodes"
      :user="user"
      :audits="audits"
      :auditHistory="auditHistory"
      @complete="getObject"
    >
      <template>
        <el-divider content-position="left">项目信息</el-divider>
        <el-form-item label="所属项目" prop="projectId">
          <el-input v-model="detail.projectName" readonly></el-input>
        </el-form-item>
        <el-form-item label="项目类别">
<!--          <el-radio-group v-model="detail.deliveryType" disabled>-->
<!--            <el-radio :label="1">系统评估</el-radio>-->
<!--            <el-radio :label="2">方案评估</el-radio>-->
<!--          </el-radio-group>-->
          <el-checkbox-group v-model="deliveryTypeList" style="cursor:not-allowed;pointer-events:none">
            <el-checkbox label="1">系统评估</el-checkbox>
            <el-checkbox label="2">方案评估</el-checkbox>
            <el-checkbox label="3">方案编制</el-checkbox>
            <el-checkbox label="4">密码应用</el-checkbox>
            <el-checkbox label="5">密码整改</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="detail.contact" readonly></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            rows="5"
            maxlength="300"
            v-model="detail.remarks"
            readonly
          ></el-input>
        </el-form-item>
      </template>
    </Detail>
  </div>
</template>

<script>
import Detail from "@/components/detail/Detail";
import { requestApplyDetail } from "@/api";

export default {
  components: { Detail },
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      nodes: [],
      user: {
        realName: "",
        deptName: "",
      },
      detail: {
        projectName: "",
        deliveryType: 1,
        contact: "",
        remarks: "",
      },
      audits: [],
      auditHistory: [],
      detailQuery: {},
      title: { name: '项目交付申请详情', path: '' },
      deliveryTypeList: []
    };
  },
  created() {
    this.applyId = this.query.applyId
    this.applyServiceId = this.query.applyServiceId
    this.applyType = this.query.applyType
    this.detailQuery.applyId = this.query.applyId
    this.detailQuery.applyServiceId = this.query.applyServiceId
    this.detailQuery.applyType = this.query.applyType
    this.getObject()
  },
  methods: {
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType,
      }).then((res) => {
        if (res.code == 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.user = res.object.user
            this.nodes = res.object.nodes
            this.deliveryTypeList = this.detail.deliveryType.split(',')
          }
        } else {
          this.$message.error(res.msg)
        }
      });
    },
  },
};
</script>
